// extracted by mini-css-extract-plugin
export default {"ChangePassword":"ChangePassword_ChangePassword__9XXvl","saveButton":"ChangePassword_saveButton__Nmf4U"};